<template>
  <v-card
    width="100%"
    :style="styleAttrs"
    :dark="!outlined"
    :class="classes"
    :color="color"
    :height="height"
  >
    <div class="content">
      <div :class="{label: true, outlined}">{{ label }}</div>
      <div v-if="description" :class="{description: true, outlined}">
        {{ description }}
      </div>
    </div>

    <z-icon
      v-if="removeIcon"
      class="remove-icon"
      @click="$emit('click:remove', $event)"
    >
      {{ removeIcon }}
    </z-icon>
  </v-card>
</template>

<script>
/**
 * @private
 */
export default {
  props: {
    label: {
      type: String,
    },

    styleAttrs: {
      type: Object,
      default: () => ({}),
    },

    description: {
      type: String,
    },

    height: {
      type: [Number, String],
      default: 60,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    removeIcon: {
      type: String,
      default: '$remove_circle_outline_rounded',
    },
  },

  computed: {
    color() {
      return this.outlined ? 'white' : 'primary'
    },
    classes() {
      return {
        'zoox-group-select': true,
        outlined: this.outlined,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.zoox-group-select {
  @extend %zoox-group-select;

  grid-template-columns: auto 30px;

  .label {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .description {
    grid-column: 1 / 2;
    grid-row: 2 / -1;
  }
}
</style>
